import type { Service } from '../../api/client'
import { groupLengths } from './packageForm'
import './Settings.css'

interface LengthChecklistProps {
  id?: string
  label: string
  services: Service[]
  ticked: string[]
  disabled?: boolean
  onToggle: (lengthId: string) => void
}

// LengthChecklist lists each service with one checkbox per length ("60 min").
// A service with a single length is one checkbox named for the service.
export default function LengthChecklist({ id, label, services, ticked, disabled, onToggle }: LengthChecklistProps) {
  return (
    <div id={id} tabIndex={id ? -1 : undefined} className="length-checklist" role="group" aria-label={label}>
      {groupLengths(services, ticked).map(({ service, lengths }) =>
        lengths.length === 1 ? (
          <label key={service.id} className="checkbox-row">
            <input
              type="checkbox"
              checked={lengths[0].checked}
              disabled={disabled}
              onChange={() => onToggle(lengths[0].length.id)}
            />
            <span className="category-dot" style={{ background: service.colour }} aria-hidden="true" />
            {service.name}
          </label>
        ) : (
          <div key={service.id} role="group" aria-label={service.name} className="length-checklist__service">
            <span className="length-checklist__name">
              <span className="category-dot" style={{ background: service.colour }} aria-hidden="true" />
              {service.name}
            </span>
            {lengths.map(({ length, checked }) => (
              <label key={length.id} className="checkbox-row length-checklist__length">
                <input
                  type="checkbox"
                  checked={checked}
                  aria-label={`${service.name} · ${length.duration_minutes} min`}
                  disabled={disabled}
                  onChange={() => onToggle(length.id)}
                />
                {length.duration_minutes} min
              </label>
            ))}
          </div>
        ),
      )}
    </div>
  )
}
